module.exports = __webpack_public_path__ + "static/media/mainImg3.69b57ebc.jpeg";